import * as Scrivito from "scrivito";

Scrivito.provideEditingConfig("ColumnWidget", {
  title: "Column",
  hideInSelectionDialogs: true,
});
